
import 'babel-polyfill';
import ReactDOM from 'react-dom';
import React, { Component } from 'react';


import HeaderContainer from './components/container/HeaderContainer';
import LatestPostsContainer from './components/container/LatestPostsContainer';
import SolutionContainer from './components/container/SolutionContainer';
import QuoteContainer from './components/container/QuoteContainer';
import WhoContainer from './components/container/WhoContainer';
import CustomersContainer from './components/container/CustomersContainer';
import CallToActionContainer from './components/container/CallToActionContainer';
import FooterContainer from './components/container/FooterContainer';
import CookieConsent from "react-cookie-consent";

export default class App extends React.Component {
  constructor(props){
    super(props);
    loading: true;
  }


  render(){ 
     return(
      <>
        <HeaderContainer  />
        <LatestPostsContainer />
        <SolutionContainer  />
        <WhoContainer  />
        <CustomersContainer />
        <QuoteContainer  />
        <CallToActionContainer  />
        <CookieConsent
          location="bottom"
          buttonText="Loka"
          cookieName="envisionAcceptCookie"
          style={{ 
            background: "#999592",
            fontSize: '15px',
          }}
          buttonStyle={{ 
            background: '#4F79AF',
            color: 'white',
            borderStyle: 'solid',
            padding: '5px 20px',
            minWidth: '140px',
            fontWeight: 'bold'
        }}
          expires={150}
        >
          Envision notar vafrakökur til að bæta upplifun notenda.{" "}
          <span >
            <a href="/personuverndarstefna" target="_blank">Sjá nánar</a> 
          </span>
        </CookieConsent>
        <FooterContainer />
    
      </>
    );
  }

  ///* <<div id="footer_container_react" ></div> 
  componentDidMount(){
    /*
    //this entry point only exists in index.hbs i.e. the langing page
    const landingPageEntryPoint =  document.getElementById("footer_container_react");
    if(landingPageEntryPoint){
      ReactDOM.render(<FooterContainer />, landingPageEntryPoint)
    }
    const removeFooter =  document.getElementById("footer_container");
    if(removeFooter){
      ReactDOM.render(<div />, removeFooter)
    }
    */
  }

}

const wrapper =  document.getElementById("app_container");
wrapper ? ReactDOM.render(<App />, wrapper) : false;
